<style lang="scss" scoped>
	@import "./quanxian.css";
	.m2 {
		display: none;
	}
	.handmiam:hover{
		.m1 {
			display: none;
		}
		.m2 {
			display: inline-block;
		}
	}
</style>
<style>
	.grayc {
		color: #cfcfcf !important;
	}

	.greenc {
		/* color: #0c8b97 !important; */
		color: #808080 !important;
	}

	#quanxian .ant-form-item-label {
		/* display: inline-block;
		height: 1px; */
		width: 5rem;
	}
</style>
<template>
	<div id="quanxian">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row type='flex' justify="space-between">
					<a-col :xl="{ span: 6 }">
						<a-form-model-item label="門禁編號" class="formItem">
							<a-input v-model="params.employee_number" placeholder="請輸入門禁編號" :allowClear="true" @change="handleClear(1)"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 6 }">
						<a-form-model-item label="員工姓名" class="formItem">
							<a-input v-model="params.name_en" placeholder="請輸入員工姓名" :allowClear="true" @change="handleClear(2)"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 6 }">
						<a-form-model-item label="使用者類型" class="formItem">
							<Situationall v-model="params.position" :url='$api.getParamList'
								:params='{"type":"position"}' :style='"width:100%"' :placeholder="'請選擇'">
							</Situationall>
						</a-form-model-item>
					</a-col>
					</a-row><br>
					<a-row type='flex' justify='space-between'>
					<a-col :xl="{ span: 6 }">
						<a-form-model-item label="電郵地址" class="formItem">
							<a-input v-model="params.email" placeholder="請輸入電郵地址" :allowClear="true" @change="handleClear(3)"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 6 }">
						<a-form-model-item label="使用狀態" class="formItem">
							<a-select v-model="params.status" placeholder="請選擇狀態" @change="searchEvent">
								<a-select-option v-for="(item) in admintypeArr" :key="item.key" :value="item.value"
									style='width:100%'>{{item.text}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 6 }" style="display: flex;align-items: center;">
						<div class="btn_cla" style="background-color:#3bc7a1;margin-right:1rem;" @click="searchEvent">
							<img src="../../image/icon_sousuo.png" class="btnIcon" />
							<span>搜索</span>
						</div>
						<div class="btn_cla" style="background-color:#ffa647;" @click="clearEvent">
							<img src="../../image/icon_chongzhi.png" class="btnIcon" />
							<span>重置</span>
						</div>
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<div @click='visible_bold = 1' class='btn_list'>
					<a-icon type="plus-circle" style="color: #a06bf1;font-size: .8rem;margin-right: .3rem;" />
					<span style="color: #a06bf1;">新建用戶</span>
				</div>
				<!-- <task :params='params' @child='fandfn' v-if='domaineditadmin'></task> -->
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index' :customRow='rowstely'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: -2.5rem;"></span>
				<div slot='status' slot-scope="record" style="white-space: nowrap;">
					<div v-if='record.status == 2' style="color: #ee5253">暫停</div>
					<div v-if='record.status == 1' style="color: #3bc7a1">使用中</div>
				</div>
				<div slot='email' slot-scope="record" style="white-space: nowrap;">{{record.email}}</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div>
							<img :src="record.visible_bold !== 1?require('../../image/lea/bianji1.png'):require('../../image/lea/bianji3.png')" class="imageC" @click='handquanxain(record)'
								>
						</div>
						<div class="popoverView handmiam">
							<!-- <a-popconfirm title="確認重置密碼？" @visibleChange="visibleShow(record,'1')"
								v-model="popconfirm1Bol" ok-text="確定" cancel-text="取消" @confirm="shTgEvent(record)"
								:getPopupContainer="triggerNode => {return triggerNode.parentNode;}"> -->
								<!-- <img :src="require('../../image/newpass.png')" class="imageC" @click="handpass(record)"> -->
								<!--   :title='record.mima'
								@mouseenter="record.mima=1" @mouseleave="record.mima=0" -->
								<img
								:src="require('../../image/mima.png')" alt="" class="imageC m1" @click="handpass(record)">
								<img
								:src="require('../../image/mima2.png')" alt="" class="imageC m2" @click="handpass(record)">
							<!-- </a-popconfirm> -->
						</div>
						<div class="popoverView" >
							<!-- <pushbtn :record='record' @child='handclose' :params='params'></pushbtn> -->
							<div @click='onChange1(1,record)' v-if='record.status == "已過期"||record.status == 2'>
								<a-icon type="play-circle"  style='color: #3bc7a1;font-size: 1.2rem;cursor:pointer;position: relative;
    top: 2px;'/> 
								<!-- 重新啟用 -->
							</div>
							<div @click='onChange1(2,record)' v-else>
								<a-icon type="pause-circle" style='color: #ffab50;font-size: 1.2rem;cursor:pointer;position: relative;
    top: 2px;'/> 
								<!-- 暫停 -->
							</div>
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<handItem v-if='visible_bold==1' @child='handclose' :items='isdate'></handItem>
	<!-- 	<handhome v-if='visible_home' @child='handclose' :items='isdate'
		:itemobj='{}' :applyid='{}'  ></handhome> -->
		<jurisdiction  v-if='visible_home' @child='handclose' :items='isdate'
		:itemobj='{}' :applyid='{}' ></jurisdiction>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
</template>
<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import handItem from './components/handItem'
	// import handhome from './components/handhome'
	import handhome from './comhome/handhome'
	import jurisdiction from './comhome/jurisdiction'
	import pushbtn from './components/pushbtn'
	import {
		saveFileToLink
	} from 'web-downloadfile';
	import task from './components/task.vue'

	export default {
		components: {
			handItem,
			task,
			pushbtn,
			jurisdiction,
			handhome
		},
		data() {
			return {
				ishandout: false,
				visible_home: false,
				isdate: '',
				visible_bold: '',
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限    
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				icon_pdf,
				icon_pdf1,
				//域名新增權限 domaininsertadmin
				//域名編輯權限 domaineditadmin
				domaininsertadmin: this.$store.state.rolesdata.indexOf('domaininsertadmin') >= 0,
				domaineditadmin: this.$store.state.rolesdata.indexOf('domaineditadmin') >= 0,
				admintypeArr: [{
					text: '全部',
					value: ''
				},{
					text: '使用中',
					value: '1'
				}, {
					text: '已暫停',
					value: '2'
				}],
				tzPageNum: '',
				columns: [{
						// title: '',
						dataIndex: '',
						align: 'center',
						width: '5%',
						slots: {
							title: 'alltext'
						},
					},
					{
						title: '門禁編號',
						dataIndex: 'employee_number',
						align: 'center',
						width: '15%'
					},
					{
						title: '員工姓名',
						dataIndex: 'name_en',
						align: 'center',
						width: '13%'
					},
					{
						title: '電郵地址',
						dataIndex: '',
						align: 'center',
						width: '17%',
						scopedSlots: {
							customRender: 'email'
						}
					},
					{
						title: '職位名稱',
						dataIndex: 'job',
						align: 'center',
						width: '13%',
					},
					{
						title: '用戶類型',
						dataIndex: 'position',
						align: 'center',
						width: '13%',
					}, {
						title: '使用狀態',
						dataIndex: '',
						align: 'center',
						width: '13%',
						scopedSlots: {
							customRender: 'status'
						}
					},

					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					position: '',
					"employee_number": "",
					"name_en": "",
					"email": "",
					status: '',
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
		},
		methods: {
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if (val == 1) {
					if (!this.params.employee_number) {
						this.messLoad()
					}
				}
				if (val == 2) {
					if (!this.params.name_en) {
						this.messLoad()
					}
				}
				if (val == 3) {
					if (!this.params.email) {
						this.messLoad()
					}
				}
            },
			onChange1(checked,v) {
				if(checked == 'drop'){
					return
				}
				this.$ajax({
					method: 'post',
					url: this.$api.editAdmin,
					data: {
						"userid":v.userid,
						"status":checked
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						// this.$emit('child', true)
						// this.visible = false
						this.handclose(true)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handquanxain(val) {
				this.visible_home = true;
				this.isdate = val
				console.log(val)
			},
			pdfEvent() {

			},
			handpass(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.editAdmin,
					data: {
						"userid": val.userid,
						"resetpassword": 1,
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.messLoad();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},
			rowstely(record, index) {
				if (record.status == "已過期"||record.status == 2) {
					return {
						style: {
							'color': '#999',
							opacity: '.5'
						},
					}
				}
			},
			deletefn(ev) {
				// this.$ajax({
				// 	method: 'post',
				// 	url: this.$api.deletOther,
				// 	headers: {
				// 		token: this.$store.state.token
				// 	},
				// 	data: {
				// 		"token": this.$store.state.token,
				// 		"systemserviceid": ev.systemserviceid,
				// 		"flag": "systemservice"
				// 	}
				// }).then(res => {
				// 	if (res.data.qmiscode === 1000) {
				// 		this.$message.success('操作成功')
				// 		this.messLoad();
				// 	} else {
				// 		this.$message.warning(res.data.qmismsg)
				// 	}
				// }).catch(err => {
				// 	console.log(err);
				// });
			},
			handediot(val, a) {
				this.isdate = val.systemserviceid;
				// console.log(val)
				this.visible_bold = a;
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			fandfn(val) {
				if (val == 'back') {
					this.params.missionflag = 0
					this.params.status = ''
				} else {
					this.params.missionflag = 1
					this.params.status = val == '即將到期' ? '3' : ''
				}
				this.messLoad()
			},
			handopen() {
				window.location.href = this.$api.getExcel + '?token=' + this.$store.state.token
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},

			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},

			fanhand1(val) {

			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {

					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handclose(val) {
				this.isdate = ''
				this.visible_bold = '';
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['visible_bold'] = ''
						ev['mima']=''
					}
				})
				this.visible_home = false;
				if (val) {
					this.messLoad();
				}
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getAdminUserList,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.adminUserList
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['visible_bold'] = ''
								ev['mima']=''
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.employee_number || this.params.name_en || this.params.position || this.params.email || this.params.status) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			clearEvent() {
				this.params = {}
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					position: '',
					"employee_number": "",
					"name_en": "",
					"email": "",
					status: '',
				}
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>


